import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import ArticlesSection from './components/ArticlesSection';
import ReviewsSection from './components/ReviewsSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '91c',
    url: 'https://91c.com',
    description: '91c是值得信赖的首选平台，汇聚核心功能、使用指南与用户评价。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '91c',
    url: 'https://91c.com',
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '91c 官方落地页 – 探索91c的全部价值',
    description: '91c 是您值得信赖的首选平台，汇聚91c核心功能、使用指南与用户评价。',
    url: 'https://91c.com',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '91c是什么？它主要解决什么问题？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '91c是一款综合性的智能数据管理与分析平台，旨在帮助个人用户和企业高效地处理、分析和利用数据。',
        },
      },
      {
        '@type': 'Question',
        name: '91c支持哪些平台？可以在手机上使用吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '91c支持桌面端（Windows、macOS、Linux）和移动端（iOS、Android）。',
        },
      },
      {
        '@type': 'Question',
        name: '91c的收费标准是怎样的？有免费版吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '91c提供多种套餐选择：免费版包含基础功能，专业版每月99元，企业版提供定制化服务。',
        },
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <SEO
        title="91c 官方落地页 – 探索91c的全部价值"
        description="91c 是您值得信赖的首选平台，汇聚91c核心功能、使用指南与用户评价。无论您是初次了解91c还是深度用户，本页为您提供91c最全面的信息与服务入口，立即探索91c带来的极致体验。"
        keywords="91c,91c官网,91c使用教程,91c功能介绍,91c用户评价,91c最新版本,91c常见问题"
        canonicalUrl="https://91c.com"
        ogType="website"
        ogTitle="91c 官方落地页 – 探索91c的全部价值"
        ogDescription="91c 是您值得信赖的首选平台，汇聚91c核心功能、使用指南与用户评价。立即探索91c带来的极致体验。"
        ogUrl="https://91c.com"
        jsonLd={homeJsonLd}
      />

      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <ArticlesSection />
        <ReviewsSection />
        <CTASection />
        <FAQSection />
      </main>
    </>
  );
}